import { ComponentType } from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import { TestResult } from './test-result';
import { TestRoom } from './test-room';

export const Test: ComponentType = () => {
  return (
    <Switch>
      <Route path={ROUTES.TEST.RESULT} component={TestResult} />
      <Route component={TestRoom} />
    </Switch>
  );
};
